import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'sonner'
import { AppProviders } from '@/app/providers'
import '@/i18n/i18n'
import App from './App'
import 'antd/dist/reset.css'
import './styles/globals.css'
import './styles/dashboard.css'
import './styles/leap-antd-data-table.css'
import './styles/leap-antd-forms.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
      <Toaster position="top-right" richColors />
    </AppProviders>
  </React.StrictMode>
)
